import { useRouter } from 'next/router';
import { RELEVANCE_SORT_OPTION } from '../constants/catalog';
import { SelectChangeEvent } from '@mui/material/Select';

export const useSort = (): {
  sortBy: string,
  handleSortChange: (sortOption: string | number | SelectChangeEvent<string | number>)=> string | number
} => {
  const router = useRouter();
  const { query: { sortBy: sortByParam } } = router;

  const sortBy = sortByParam ? decodeURIComponent(sortByParam?.toString()) : RELEVANCE_SORT_OPTION;

  const handleSortChange = (sortOption: string | number | SelectChangeEvent<string | number>): string | number => {
    const sortBy = typeof sortOption === 'string' || typeof sortOption === 'number'
      ? sortOption
      : sortOption.target.value;

    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        sortBy: encodeURIComponent(sortBy)
      }
    }, undefined, { shallow: true });

    return sortBy;
  };

  return { sortBy, handleSortChange };
};
